var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_15274","data-name":"Group 15274","transform":"translate(-1224.379 -59)"},[React.createElement("rect",{"id":"Rectangle_199","data-name":"Rectangle 199","width":"21","height":"21","transform":"translate(1225 59)","fill":"none","key":0}),React.createElement("path",{"id":"Path_5","data-name":"Path 5","d":"M6060.271-287.756l-9,9-9-9","transform":"translate(7286.771 -213.256) rotate(180)","fill":"none","stroke":"#818181","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3","key":1})]));
}

Arrow.defaultProps = {"width":"22.242","height":"21","viewBox":"0 0 22.242 21"};

module.exports = Arrow;

Arrow.default = Arrow;
